<div class="h-full w-full">
  <div class="mx-auto">
    @if (currentUser(); as user) {
      <section class="mb-8">
        <h2 class="mb-2 text-2xl text-gray-900">
          ようこそ、{{ user.displayName }}さん！
        </h2>
        <p class="text-gray-600">左のメニューからタスクを開始しましょう！</p>
      </section>
    }

    @if (canShowLinks()) {
      <hr class="my-8 h-px border-none bg-gray-200" />
      <section class="mb-8">
        <h2 class="mat-headline-6">社内向けリンク集</h2>

        <div class="space-y-6">
          @for (group of linkData.groups; track group.name) {
            <div
              class="rounded-lg border border-gray-200 bg-white p-6 shadow-sm"
            >
              <h3 class="mb-4 text-lg font-medium text-gray-700">
                {{ group.name }}
              </h3>
              <ul class="space-y-3">
                @for (link of group.links; track link.url) {
                  <li>
                    <a [href]="link.url" appLink external>
                      {{ link.label }}
                    </a>
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      </section>
    }
  </div>
</div>
